import { companySchema } from "@/schema/Company";
import { statusSchema } from "@/schema/Status";
import { answerSheetSchema } from "@/schema/console/certifications/AnswerSheet";
import { z } from "zod";

export const certificationSchema = z.object({
  id: z.number(),
  status: statusSchema,
  company: companySchema,
  answer_sheets: z.array(answerSheetSchema),
  issued_at: z.coerce.date().nullish(),
});

export type Certification = z.infer<typeof certificationSchema>;
